import React, { useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import ReactTable from 'srcReact/components/common2/ReactTable'
import { getWorkplaceInviteSent } from 'srcReact/helpers/utils'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import Spinner from 'srcReact/components/common2/Spinner'
import { workplaceSettingsActions } from 'srcReact/WorkplaceSettingsPage'
import { inviteActions } from 'srcReact/components/common2/InviteWPMembers/actions'
import { appConstantSettings } from 'srcReact/appConstantSettings'

const Pending = ({ selectedWorkplace, setPagination }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    invite: { loading },
    workplaceSettings: { manage_invites }
  } = useSelector((state) => state)
  const [email, setEmail] = useState('')

  const handleInvite = (data, type) => {
    if (type === 'send') {
      setEmail(data?.email)
      dispatch(inviteActions.inviteToWorkplace(selectedWorkplace?.id, data?.email))
    } else if (type === 'cancel') {
      dispatch(workplaceSettingsActions.deleteWorkplaceInvitation(data?.id))
    }
  }
  const options = (row) => {
    let actions = []
    actions.push({
      text: t('global.sendAgain'),
      onClick: () => handleInvite(row, 'send')
    })
    actions.push({
      text: t('global.cancelInvite'),
      onClick: () => handleInvite(row, 'cancel')
    })
    return actions
  }
  const pendingColumns = useMemo(
    () => [
      {
        Header: t('workplaceSettings.manageInvites.pending.invitee'),
        accessor: 'email',
        className: styles.rowEmail
      },
      {
        Header: t('workplaceSettings.manageInvites.pending.inviteSent'),
        id: 'sent_at',
        accessor: (row) =>
          loading && row?.email === email ? (
            <Spinner customCss={styles.spinnerCustomCss} />
          ) : (
            <div className={styles.memberSince}>{getWorkplaceInviteSent(t, row?.sent_at || row?.created_at)}</div>
          ),
        className: styles.rowMemberSince
      },
      {
        Header: '',
        id: 'options',
        className: styles.options,
        accessor: (row) => <ReactMenu options={options(row)} />
      }
    ],
    [loading, email]
  )
  const handleCurrentPage = (page) => {
    const nextOffset = (page - 1) * appConstantSettings.WORKPLACE_PAGINATION_QUANTITY
    setPagination({ nextOffset, isPagination: true })
  }

  return (
    <div className={styles.manageInvitesPending}>
      <ReactTable
        columns={pendingColumns}
        data={manage_invites?.invitations}
        className={styles.tableClassName}
        loading={manage_invites?.loading}
        pagination={{
          total: manage_invites?.stats?.total,
          offset: manage_invites?.stats?.next_offset
        }}
        pageSize={appConstantSettings.WORKPLACE_PAGINATION_QUANTITY}
        handleCurrentPage={handleCurrentPage}
      />
    </div>
  )
}

export default Pending
